export default __webpack_public_path__ + "images/galactic-master.svg";